import React from 'react';
import { components } from 'react-select';

export const PresetRoleOptionMultiValueLabel = (props) => {
  return (
    <components.MultiValueLabel {...props}>
      {props.data.country}:{props.children}
    </components.MultiValueLabel>
  );
};
